import { cn } from '@/shared/utils/cn';
import React from 'react';
import { ListItemCheckbox } from '../molecules/ListItemCheckbox';

export interface ListWithCheckboxItem {
  id: string;
  title: string;
  description?: string;
  checked?: boolean;
  disabled?: boolean;
}

export interface ListWithCheckboxProps {
  items: ListWithCheckboxItem[];
  onCheckboxChange?: (itemId: string, checked: boolean) => void;
  className?: string;
}

export const ListWithCheckbox: React.FC<ListWithCheckboxProps> = ({
  items,
  onCheckboxChange,
  className,
}) => {
  return (
    <div
      className={cn(
        'ui-rounded-surface-card ui-border ui-border-default ui-bg-fill ui-p-8 ui-shadow-03',
        'ui-flex ui-min-w-[320px] ui-flex-col ui-gap-8',
        className,
      )}
    >
      {items.map((item) => (
        <ListItemCheckbox
          key={item.id}
          title={item.title}
          description={item.description}
          checked={item.checked}
          disabled={item.disabled}
          onChange={(checked) => onCheckboxChange?.(item.id, checked)}
        />
      ))}
    </div>
  );
};
